<div class="overlay-content">
  <div class="overlay">
    <div class="content">
      <div class="icon" *ngIf="navigatorOnline">
        <img
          src="assets/icons/check-circle-white.svg"
          alt="{{ 'call.CHECK_ALT' | transloco }}"
        />
      </div>
      <div class="title">
        {{ title }}
      </div>
      <ng-container
        *ngIf="navigatorOnline && !hasError() && !isSavedConversation()"
      >
        <div *ngIf="isLoading()" class="loading-container">
          <qai-loading [size]="'small'"></qai-loading>
        </div>
        <p class="sub-title">
          {{ subtitle }}
        </p>
      </ng-container>
      <ng-container *ngIf="hasError() && !isSavedConversation()">
        <div class="error-container">
          <p class="error-message">
            {{ errorMessage() }}
          </p>
          <a class="help-email" href="mailto:support@quantified.ai">{{
            helpEmail
          }}</a>
        </div>
      </ng-container>
      <ng-container *ngIf="isSavedConversation()">
        <p class="sub-title">
          {{ subtitleSavedConversation }}
        </p>
      </ng-container>
      <ng-container *ngIf="navigatorOnline">
        <div *ngIf="!feedbackSubmitted" class="feedback">
          <p class="rating-text">
            {{ question }}
          </p>
          <div class="rating-icon">
            <quant-button
              class="thumbs-up"
              type="button"
              label=""
              hierarchy="secondary-gray-dark"
              size="md"
              iconLeading="assets/icons/thumbs_up.svg"
              (onClick)="submitFeedback(true)"
            ></quant-button>
            <quant-button
              class="thumbs-down"
              type="button"
              label=""
              hierarchy="secondary-gray-dark"
              size="md"
              iconLeading="assets/icons/thumbs_down.svg"
              (onClick)="submitFeedback(false)"
            ></quant-button>
          </div>
        </div>
        <div *ngIf="feedbackSubmitted" class="feedback feedback-submit">
          <img
            *ngIf="selectedFeedback"
            class="party-icon"
            src="assets/icons/partying-face.svg"
            alt="{{ 'call.PARTY_EMOJI' | transloco }}"
          />
          <p class="feedback-text">{{ thankYouMessage }}</p>
        </div>
      </ng-container>

      <button
        qai-button
        [kind]="'primary'"
        [size]="'large'"
        [disabled]="isLoading()"
        (click)="controlService?.goBackToAssigment()"
      >
        {{ "call.RETURN_TO_MY_ASSIGNMENTS" | transloco }}
      </button>
    </div>
  </div>
</div>

<!-- Error Modals -->
<div
  class="overlay-modal"
  *ngIf="controlService?.isNetworkError || controlService?.isEndCallError"
>
  <div class="modal" *ngIf="controlService?.isNetworkError">
    <p class="info">
      {{ "call.HAVING_ISSUES" | transloco }}
    </p>

    <button
      qai-button
      [size]="'large'"
      [kind]="'primary'"
      (click)="clickErrorModalOK()"
    >
      {{ "call.OK" | transloco }}
    </button>
  </div>

  <div
    class="modal"
    *ngIf="controlService?.isEndCallError && !controlService?.isNetworkError"
  >
    <p class="info">
      {{ "call.RESULTS_NOT_GENERATED" | transloco }}
    </p>
    <button
      qai-button
      [kind]="'primary'"
      [size]="'large'"
      (click)="clickErrorModalReturnAssignment()"
    >
      {{ "call.RETURN_TO_MY_ASSIGNMENTS" | transloco }}
    </button>
  </div>
</div>
